module.exports = __webpack_public_path__ + "img/avatar7.8f135b3e.png";